import React, {useEffect, useState} from 'react';
import {connect, WithStore, MapStateToProps, MapDispatchToProps} from '../../redux/services/Imports';
import './PageVacancies.scss';
import './PageVacancies-media.scss';

import Content from '../../components/Content/Content';
import FormVacancies from '../../components/FormVacancies/FormVacancies';
import {Props} from './interfaces';

const PageVacancies = ({widthWindow}: Props) => {

  const [widthContent, setWidthContent] = useState('1280px');

  useEffect(() => {
    setWidthContent(widthWindow > 720 ? '1000px' : 'calc(100% - 40px)');
  }, [widthWindow]);

  return (
    <Content
      width={widthContent}
      block={<FormVacancies />}
    />
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageVacancies));
